import { AddressDto } from './address-dto';

export class User {
    username: string;
    email: string;
    password: string;
    tenantId: number;
    roles: string[];
    firstName: string;
    lastName: string;
    fatherName: string;
    motherName: string;
    phoneNumber: string;
    gender?: string;
    bloodGroup?: string;
    addressDto?: Partial<AddressDto>;
    mobileNumber?: number;
    constructor() { }
}
